import React from "react";
import GalleryImg from "../../Components/Gallery/GalleryImg";
import SimpleBanner from "../Common/SimpleBanner";
import Aboutbanar from "../../Assets/Gallery/Gallerybannerimgs.png";
import { Helmet } from "react-helmet";
const Gallery = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>GoCabz Travel Gallery – Cab Services in Bhubaneswar</title>
        <meta
          name="description"
          content="View the GoCabz gallery showcasing our fleet, happy customers, and travel experiences.
See why people trust us for cab services in Bhubaneswar.
"
        />
        <link rel="canonical" href="https://www.gocabz1.com/gallery/" />
      </Helmet>
      <SimpleBanner
        image={Aboutbanar}
        name="Our Gallery"
        path="Home / Our Gallery"
      />
      <GalleryImg />
    </div>
  );
};

export default Gallery;
